import { pxToRem, stack, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { colors, spacing } = theme;

export const quickFilters = css`
  padding: ${stack(spacing.xxl)};
  margin: ${stack(spacing.xxl)};
  border-bottom: ${pxToRem(1)} solid ${colors.neutralLight};
`;
